const lang = {
  contact: 'Kapcsolat',
  experience: 'Munkatapasztalat',
  education: 'Tanulmány',
  skills: 'Készségek',
  about: 'Rólam'
};
export default lang;



// WEBPACK FOOTER //
// ./src/lang/hu.js